// extracted by mini-css-extract-plugin
module.exports = {"productName":"_1oU8u","bottomGutter":"_2zovr","horizontalTextAlign":"jeh9p","verticalTextAlign":"Ob5UY"};